var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"link-button",attrs:{"type":"button"}},[_c('span',{staticClass:"link-button__content"},[_vm._t("default",function(){return [_vm._v(" Características ")]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }